import React, {Component} from 'react'
import {connectHits} from 'react-instantsearch-dom'
import {isCa} from '@/scripts/util/countryCheck'
import {formatCurrencyByLocale} from '../../../../util/formatCurrencyByLocale'

const AlgoliaSearchResultListItem = ({ children, id, type, index, label }) => {
    return type === index ? (
        <div className={`search-bar-results-main search-bar__results search-bar__results--${index}`}>
            <h6 className="search-bar__result-label">{label}</h6>
            <div
                className={`search-bar__result-wrapper search-bar__result-wrapper--${index} margin-bottom-3x`}
                id={id}
            >
                {children}
            </div>
        </div>
    ) : null
}
class Hits extends Component {
    constructor(props) {
        super(props)
    }

    componentDidUpdate() {
        const { hits, results, type, updateResults } = this.props
        if (hits) {
            if (results[type] != hits.length) {
                updateResults(type, hits.length)
            }
        }
    }

    render() {
        const { hits, type } = this.props
        return hits && hits.length > 0 ? (
            <div className="search-main-wrapper wide">
                {type === `products` ? (
                    <AlgoliaSearchResultListItem
                        id={`productResults`}
                        type={type}
                        index={`products`}
                        label={`Products`}
                    >
                        {hits.map(product => {
                                const url = `${window.Shopify.locale === `fr` ? `/fr`: ``}/products/${product.handle}`
                                const imageUrl = product.image ? product.image : `//cdn.shopify.com/s/files/1/0627/6802/1734/files/placeholder.png?v=1735639480`
                                const truncatedDescription = product.body_html_safe.length > 100 ? product.body_html_safe.substring(0, 80) + `...` : product.body_html_safe
                                return (
                                    <a key={product.objectID} href={url} className="block">
                                        <div className="search-products-inner">
                                            <div className="search-product-image">
                                                <img src={imageUrl} alt={product.title}/>
                                            </div>
                                            <div className="search-product-info">
                                                <h4 className="search-product-title text-large">{product.title}
                                                </h4>
                                                <p className="search-product-description text-medium">{truncatedDescription}
                                                </p>
                                            </div>
                                        </div>
                                    </a>
                                )
                            })}
                    </AlgoliaSearchResultListItem>
                ) : ``}
                {type === `collections` ? (
                    <AlgoliaSearchResultListItem
                        id={`collectionsResults`}
                        type={type}
                        index={`collections`}
                        label={`Categories`}
                    >
                        {hits.map(collection => {
                                const url = `${window.Shopify.locale === `fr` ? `/fr`: ``}/collections/${collection.handle}`
                                return (
                                    <a key={collection.objectID} href={url} className="block">
                                        <p className="text-medium">{collection.title}</p>
                                    </a>
                                )
                            })}
                    </AlgoliaSearchResultListItem>
                ) : ``}
                {(type === `articles` && !(isCa() && window.Shopify.locale === `fr`))? (
                    <AlgoliaSearchResultListItem
                        id={`blogResults`}
                        type={type}
                        index={`articles`}
                        label={`Resources`}
                    >
                        {hits.map(article => {
                                const url = `/blogs/${article.blog.handle}/${article.handle}`
                                const date = new Date(article.published_at).toDateString()
                                return (
                                    <a key={article.objectID} href={url} className="block">
                                        <p className="text-medium">{article.title}</p>
                                        <p className="foreground-dark-green text-medium">
                                            Article Published: {date}
                                        </p>
                                    </a>
                                )
                            })}
                    </AlgoliaSearchResultListItem>
                ) : ``}
            </div>
        ) : null
    }
}

const CustomHits = connectHits(Hits)

export default CustomHits
